import defaultConfig from '../../../../helpers/example-data/defaultConfig.json'
import { Image } from 'react-bootstrap'
import { useEffect, useState, useRef } from 'react'
import ReactModal from 'react-modal'
import CropModal from './cropModal'
import { FILE_UPLOAD_URL } from '../../../../env'
import axios from 'axios'
import 'react-image-crop/dist/ReactCrop.css'
import { centerCrop, makeAspectCrop } from 'react-image-crop'

interface IProps {
  config: any
  setConfig: React.Dispatch<React.SetStateAction<any[]>>
  data: any
  closeModal: () => void
}

function centerAspectCrop(mediaWidth: number, mediaHeight: number, aspect: number) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 30
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  )
}

const CustomPallete: React.FC<IProps> = ({ config, setConfig, data, closeModal }) => {
  const [defaultState, setDefaultState] = useState<any>([])
  const [newAvatar, setNewAvatar] = useState<string>('')
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [loader, setLoader] = useState<boolean>(false)

  //  crop
  const [src, setSrc] = useState<any>(null)
  const [crop, setCrop] = useState<any>({ unit: '%', width: 30, aspect: 1 })
  const [croppedImageUrl, setCroppedImageUrl] = useState<any>(null)
  const imageRef = useRef<HTMLImageElement | null>(null)
  const fileUrl = useRef<string | null>(null)
  const [aspect] = useState<number | undefined>(1)
  const [prevImgUrl, setPrevImgUrl] = useState('')
  const fileInputRef = useRef<any>(null)

  const handleClick = (e: any, avatarNumber: '1' | '2' | '3' | '4' | '5' | 'Dark') => {
    e.preventDefault()
    const keyIndex = `theme${avatarNumber}`
    const themeColorPalette = (defaultConfig as any)[keyIndex].colorPalette
    if (avatarNumber !== 'Dark') {
      setConfig((prevConfig: any) => ({
        ...prevConfig,
        theme: {
          ...prevConfig.theme,
          colorPalette: {
            ...prevConfig.theme.themeColorPalette,
            color1: themeColorPalette.color1,
            color2: themeColorPalette.color2,
            color3: themeColorPalette.color3
          },
          headerAvatarStyle: {
            ...prevConfig.theme.headerAvatarStyle,
            content: `url(https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/avatars/avatar${avatarNumber}.png)`
          },
          botAvatarStyle: {
            ...prevConfig.theme.botAvatarStyle,
            content: `url(https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/avatars/avatar${avatarNumber}.png)`
          },
          iconHref: `https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/avatars/avatar${avatarNumber}.png`,
          darkTheme: false
        }
      }))
    } else {
      setConfig((prevConfig: any) => ({
        ...prevConfig,
        theme: {
          ...prevConfig.theme,
          colorPalette: {
            color1: prevConfig.theme.colorPalette.color1,
            color2: prevConfig.theme.colorPalette.color2,
            color3: prevConfig.theme.colorPalette.color3,
            ...prevConfig.theme.themeColorPalette
          },
          headerAvatarStyle: {
            ...prevConfig.theme.headerAvatarStyle,
            content: `url(https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/avatars/avatar${avatarNumber}.png)`
          },
          botAvatarStyle: {
            ...prevConfig.theme.botAvatarStyle,
            content: `url(https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/avatars/avatar${avatarNumber}.png)`
          },
          iconHref: `https://chatbot-project.s3.ap-south-1.amazonaws.com/botgo/avatars/avatar${avatarNumber}.png`
        }
      }))
    }
  }

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect) {
      const { width, height } = e.currentTarget
      setCrop(centerAspectCrop(width, height, aspect))
    }
  }

  useEffect(() => {
    setDefaultState(defaultConfig)
    console.log(config.theme.iconHref)
  }, [defaultConfig])

  const openModal = () => {
    setIsModalOpen(true)
  }

  const afterOpenModal = () => {
    // subtitle.style color = '#f00'
  }

  const closeModals = () => {
    setIsModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '45%',
      left: '40%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-15%, -45%)',
      border: '2px solid #dde'
    }
  }

  const onCropComplete = (cropCompleted: any) => {
    makeClientCrop(cropCompleted)
  }

  const makeClientCrop = async (cropClientCrop: any) => {
    if (imageRef.current && cropClientCrop.width && cropClientCrop.height) {
      const croppedImageUrl1 = await getCroppedImg(imageRef.current, cropClientCrop, 'newFile.jpeg')
      console.log('Cropped Image URL:', croppedImageUrl1) // Add this line for debugging
      setCroppedImageUrl(croppedImageUrl1)
    }
  }

  const getCroppedImg = (image: HTMLImageElement, crop1: any, fileName: string) => {
    const canvas = document.createElement('canvas')
    const pixelRatio = window.devicePixelRatio
    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    canvas.width = crop1.width * pixelRatio * scaleX
    canvas.height = crop1.height * pixelRatio * scaleY
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop1.x! * scaleX,
      crop1.y! * scaleY,
      crop1.width! * scaleX,
      crop1.height! * scaleY,
      0,
      0,
      crop1.width! * scaleX,
      crop1.height! * scaleY
    )
    return new Promise<string | null>((resolve, reject) => {
      canvas.toBlob(
        (file: any) => {
          file.name = fileName
          window.URL.revokeObjectURL(fileUrl.current!)
          setPrevImgUrl(window.URL.createObjectURL(file))
          resolve(file)
        },
        'image/jpeg',
        1
      )
    })
  }

  const HandleBotAvatar = async (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      reader.onload = () => {
        setSrc(reader.result)
        setPrevImgUrl('') // Clear the previous image URL
      }
      reader.readAsDataURL(e.target.files[0])
    }
    setLoader(false)
    openModal()
    // Clear the input value
    fileInputRef.current.value = ''
  }

  async function imageUpload(file: any) {
    setLoader(false)
    let files: any = []
    files.push({
      fileName: file.name,
      mimeType: file.type
    })

    const dataFiles = { files }

    try {
      let response = await axios.post(FILE_UPLOAD_URL as string, dataFiles)
      // Need to optimise this logic later to handle multiple file uploads

      // console.log(response.data[1])
      const uploadURL = response.data[0].uploadURL

      const fileUrl1 = response.data[0].url
      // Send file to uploadURL after the url is created in s3
      const finalresponse = await axios.put(uploadURL, file)
      console.log(finalresponse)

      console.log(fileUrl1)

      setTimeout(() => {
        setLoader(false)
      }, 1000)

      return fileUrl1
    } catch (err) {
      console.log(err)
      setLoader(false)
      return null
    }
  }

  const handleNewBotAvatarClick = () => {
    const theme1ColorPalette = defaultConfig.theme1.colorPalette

    setConfig((prevConfig: any) => ({
      ...prevConfig,
      theme: {
        ...prevConfig.theme,
        headerAvatarStyle: {
          ...prevConfig.theme.headerAvatarStyle,
          content: `url(${newAvatar})`
        },
        botAvatarStyle: {
          ...prevConfig.theme.botAvatarStyle,
          content: `url(${newAvatar})`
        },
        iconHref: newAvatar,
        colorPalette: {
          color1: theme1ColorPalette.color1,
          color2: theme1ColorPalette.color2,
          color3: theme1ColorPalette.color3
        }
      }
    }))
  }

  const onCropBtnClick = async () => {
    let uploadUrl = await imageUpload(croppedImageUrl)
    setLoader(true)
    // Set the new avatar URL only after the upload is complete
    setNewAvatar(uploadUrl)
    const keyIndex = `theme${1}`
    const themeColorPalette = (defaultConfig as any)[keyIndex].colorPalette
    setConfig((prevConfig: any) => ({
      ...prevConfig,
      theme: {
        ...prevConfig.theme,
        colorPalette: {
          ...prevConfig.theme.themeColorPalette,
          color1: themeColorPalette.color1,
          color2: themeColorPalette.color2,
          color3: themeColorPalette.color3
        },
        headerAvatarStyle: {
          ...prevConfig.theme.headerAvatarStyle,
          content: `url(${uploadUrl})`
        },
        botAvatarStyle: {
          ...prevConfig.theme.botAvatarStyle,
          content: `url(${uploadUrl})`
        },
        iconHref: uploadUrl,
        darkTheme: false
      }
    }))

    console.log('croppedImageUrl', uploadUrl)
    console.log('ddddddddddd')
    setLoader(false)
    closeModals()
  }

  useEffect(() => {
    const isIconHrefInDefaultConfig = Object.values(defaultConfig).some((theme: any) => {
      return theme.iconHref === config.theme.iconHref
    })

    if (isIconHrefInDefaultConfig) {
      // config.theme.iconHref is present in defaultConfig
      console.log('config.theme.iconHref is present in defaultConfig')
    } else {
      // config.theme.iconHref is not present in defaultConfig
      console.log('config.theme.iconHref is not present in defaultConfig')
      setNewAvatar(config.theme.iconHref)
    }
  }, [])

  return (
    <>
      <div className='pallete-header fs-2 fw-bolder'>Configuration</div>
      <div className='d-flex flex-column'>
        <div>
          <div className='mt-7 fs-4 fw-bolder'>Select an Avatar</div>
          <>
            <div className='d-flex mt-4 mb-n5 flex-wrap'>
              {Object.keys(defaultState).map((themeKey: any, index: any) => {
                const theme = defaultState[themeKey]
                if (themeKey !== 'themeDark') {
                  return (
                    <Image
                      key={themeKey}
                      role='button'
                      className='me-n1 mb-n1 rounded-circle mt-4 w-100px h-100px '
                      src={theme.iconHref}
                      onClick={(e) => handleClick(e, index + 1)}
                      style={{
                        objectFit: 'contain',
                        transform: 'scale(0.6)',
                        transformOrigin: '0 0',
                        borderRadius: '50%'
                      }}
                    />
                  )
                }
                return null
              })}
              <div className='d-flex mt-0'>
                {!!loader ? (
                  <>
                    <div className='loader-container'>
                      <div className='loader'></div>
                    </div>
                  </>
                ) : (
                  <>
                    {!!newAvatar && (
                      <Image
                        role='button'
                        className='me-n1 mb-n1 rounded-circle mt-4 w-100px h-100px'
                        src={newAvatar}
                        onClick={handleNewBotAvatarClick}
                        style={{
                          objectFit: 'contain',
                          transform: 'scale(0.6)',
                          transformOrigin: '0 0',
                          boxShadow: ' 0 2px 5px 1px rgba(107, 104, 104, 0.5)',
                          borderRadius: '50%'
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div className='d-flex mt-2 mb-8 mx-1'>
                <label
                  htmlFor='upload-button'
                  className='rounded-circle p-2'
                  style={{
                    height: '60px',
                    width: '60px',
                    marginRight: '8px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 3px 1px rgba(165, 161, 161, 0.5)',
                    outline: 'none',
                    border: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <i className='bi bi-upload' style={{ fontSize: '24px' }} />
                </label>

                <input
                  type='file'
                  id='upload-button'
                  accept='image/*'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={HandleBotAvatar}
                />
              </div>
            </div>
            {isModalOpen && (
              <ReactModal
                isOpen={isModalOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModals}
                style={customModalStyles}
                contentLabel='Edit User'
              >
                <CropModal
                  crop={crop}
                  setCrop={setCrop}
                  onCropComplete={onCropComplete}
                  aspect={aspect}
                  imageRef={imageRef}
                  src={src}
                  onImageLoad={onImageLoad}
                  croppedImageUrl={prevImgUrl}
                  closeModal={closeModals}
                  setLoader={setLoader}
                  onCropBtnClick={onCropBtnClick}
                />
              </ReactModal>
            )}
          </>
        </div>
        <div className='d-flex ms-auto mt-auto'>
          <button
            className='btn btn-secondary me-4'
            onClick={() => {
              closeModal()
            }}
          >
            <i className='bi bi-eye-fill' /> Preview
          </button>
          <button className='btn btn-primary'>
            <i className='bi bi-save' /> Save
          </button>
        </div>
      </div>
    </>
  )
}

export default CustomPallete
